<template>
  <div
    ref="usageTrack"
    :v-if="checkCookieDrop"
  />
</template>

<script>
import {
  setCookie,
  getCookieVal,
} from 'mixins/composition/CookieApi';
import agencyCookies from 'config/cookieDrop';

export default {
  name: 'AgencyCookieDrop',
  props: {
    agencyNumber: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      setCookie,
      getCookieVal,
    };
  },
  data() {
    return {
      agencyCookies,
      usageTracker: [],
    };
  },
  computed: {
    checkCookieDrop() { // check if given agencyNumber is relevant and return configuration
      const cookieData = this.agencyCookies.find((agency) => agency.agencyNumber === this.agencyNumber);
      if (typeof cookieData !== 'undefined' && cookieData.trackUrl !== '') {
        return cookieData;
      }
      return false;
    },
  },
  mounted() {
    const usageTrackerCookie = getCookieVal('usageTracker');
    if (usageTrackerCookie) {
      this.usageTracker = JSON.parse(usageTrackerCookie);
    }
    if (!Array.isArray(this.usageTracker)) {
      this.usageTracker = [];
    }

    // check if agencyNumber was dropped before
    if (!this.usageTracker.includes(this.agencyNumber)) {
      this.dropCookie(this.checkCookieDrop);
    }
  },
  methods: {
    storeCookieDrop(agencyNumber) {
      // check if agencyNumber was dropped before
      if (!this.usageTracker.includes(agencyNumber)) {
        this.usageTracker.push(agencyNumber);
        setCookie({
          name: 'usageTracker',
          value: JSON.stringify(this.usageTracker),
          expires: '30d',
        });
      }
    },
    dropCookie(cookieData) {
      if (cookieData?.trackType === 'script') { // create script tag with trackUrl
        if (document.head) {
          const droppingScript = document.createElement('script');
          droppingScript.setAttribute('src', cookieData.trackUrl);
          document.head.appendChild(droppingScript);
        }
        this.storeCookieDrop(cookieData.agencyNumber); // remember dropped agencyNumber
      } else if (cookieData?.trackType === 'image') { // create image tag with trackUrl
        const droppingImage = document.createElement('img');
        droppingImage.setAttribute('src', cookieData.trackUrl);
        droppingImage.setAttribute('class', 'd-none');
        this.$refs.usageTrack.appendChild(droppingImage);
        this.storeCookieDrop(cookieData.agencyNumber); // remember dropped agencyNumber
      }
      return false;
    },
  },
};
</script>
